import { render, staticRenderFns } from "./ReviewStars.vue?vue&type=template&id=38b91c12&scoped=true&"
import script from "./ReviewStars.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewStars.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewStars.vue?vue&type=style&index=0&id=38b91c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b91c12",
  null
  
)

export default component.exports